import { Title, Description } from '~/components/typography';
import { Wrapper } from '../errors/error.util';

export const Maintenance = () => (
  <Wrapper testId="screen-Maintenance">
    <Title textAlign="center" marginTop="48px">
      We&rsquo;re down for scheduled maintenance.
    </Title>
    <div style={{ width: '353px', marginLeft: 'auto', marginRight: 'auto' }}>
      <Description textAlign="center" marginTop="24px">
        Our service is temporarily unavailable. Please check back soon.
      </Description>
    </div>
  </Wrapper>
);
